import HelpTooltip from '@/app/common/components/HelpTooltip';
import { guideTooltipHtml } from './CoverageHelpTip';

const INDEX_LIMIT_GUIDE = {
  matchKey: 'index-limit-200',
  title: 'حداکثر ۲۰۰ آدرس',
  paragraphs: [
    'این سقف مربوط به سهمیه روزانه Indexing API گوگل است و امکان افزایش آن از سمت ما وجود ندارد؛ بهتر است درخواست‌ها را بهینه مصرف کنید.',
    'قبل از ارسال، با «تست ۲۰۰» آدرس‌های اشتباه و ۴۰۴ را از لیست خارج کنید.',
    'یا بهتر است ابتدا از بخش «وضعیت ایندکس» همان URLها را بررسی کنید و فقط آدرس‌هایی را بفرستید که ایندکس نیستند.',
  ],
};

export function IndexLimitHelpTip() {
  return (
    <HelpTooltip
      html={guideTooltipHtml(INDEX_LIMIT_GUIDE)}
      placement="top"
      className="ms-1"
    />
  );
}
